import request from "src/utils/request";
import getOverview from "src/scenes/teams/dashboard/mock-data/overview";
import useDashboardApi from "src/scenes/teams/dashboard/hooks/use-dashboard-api";

const useOverviewApi = (teamId) => {
    const requestHandler = (abortController) => {
        return request(`/api/data/fundamentals/teams/${teamId}/v1/overview`, { abortController });
    };

    return useDashboardApi(
        () => getOverview(),
        ({ abortController }) => requestHandler(abortController),
        undefined,
        `/api/data/fundamentals/teams/${teamId}/v1/overview`
    );
};

export default useOverviewApi;
